export const USER_GET_LIST = "/user";